
import { useCallback, useEffect, useState } from "react"

export const useSubnetMappingsOverview = (directTunnelData) => {

	const [scheduledValue, setScheduledValue] = useState(0)
	const [permanentValue, setPermanentValue] = useState(0)

	const calculateSubnetMappings = useCallback((directTunnelData) => {
		directTunnelData.forEach(tunnel =>
			tunnel.activated_time ?
				tunnel.deactivated_time ?
					setScheduledValue(prev => prev + 1) :
					setPermanentValue(prev => prev + 1)
				: setPermanentValue(prev => prev + 1) // Dormant
		)
	}, [directTunnelData])

	useEffect(() => {
		directTunnelData && calculateSubnetMappings(directTunnelData)
		return () => {
			setScheduledValue(0)
			setPermanentValue(0)
		}
	}, [directTunnelData])

	return { scheduledValue, permanentValue }
}